import React, { PropsWithChildren } from 'react';
import 'react-loading-skeleton/dist/skeleton.css';
import { Outlet } from 'react-router-dom';
import { Footer } from './Footer';
import TiltContextProvider from '../contexts/TiltContext';
import { Page } from './LayoutComponents';
import { Box } from '@mui/material';
import ModalContextProvider from '@contexts/ModalContext';
import OfflineSymbolContextProvider from '@/contexts/OfflineSymbolContext';

export const SharedProviders: React.FC<PropsWithChildren> = ({ children }): JSX.Element => {
  return (
    <OfflineSymbolContextProvider>
      <ModalContextProvider>
        <TiltContextProvider>{children}</TiltContextProvider>
      </ModalContextProvider>
    </OfflineSymbolContextProvider>
  );
};

const SharedLayout: React.FC = (): JSX.Element => {
  return (
    <SharedProviders>
      <Page>
        <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
          <Outlet />
          <Footer />
        </Box>
      </Page>
    </SharedProviders>
  );
};

export default SharedLayout;
